import Home from "./pages/Home";
import LayoutHOC from "./Components/Layout";
import "./App.css";

const App = LayoutHOC(() => {
  return <Home />;
});

export default App;
